<default-popup-wrapper-component [globalPopup]="globalPopup"
                                 [title]="globalPopup.title"
                                 (onClose)="closePopup($event)"
                                 [componentRef]="this">
    <map-item-importer #importer></map-item-importer>
</default-popup-wrapper-component>
